(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('checkListItemCvs', {
        templateUrl: 'views/components/views/checkListItemCvs/checkListItemCvs.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'modalService', 'stateService', 'utilityService', 'translateService', 'checkListItemCvsService', function ($stateParams, modalService, stateService, utilityService, translateService, checkListItemCvsService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let checkListItemKeyno = $stateParams.checklistitem_keyno;

            let translations = {
                error: '',
                ok: ''
            };

            vm.model = {
                searchTextButtons: [
                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.setting.searchtext = '' }
                ],
                setting: {},
                itemsListCalculationAndValidations: [],
                lockedSave: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATION FUNCTION

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATION FUNCTION

            // #region LOAD PROCEDURE FUNCTIONS

            async function loadSetting() {
                vm.model.setting = (await checkListItemCvsService.getSetting({ checklistitem_keyno: checkListItemKeyno }))[0];
            }
            
            async function loadCalculationAndValidations() {
    			if (utilityService.validateParmsValue(vm.model.setting.checklistitem_keyno) !== true) return;
                
                return vm.model.itemsListCalculationAndValidations = await checkListItemCvsService.listCalculationAndValidations({ checklistitem_keyno: vm.model.setting.checklistitem_keyno });
    		}

            // #endregion LOAD PROCEDURE FUNCTIONS

            // #region TOGGLE CHOSEN FUNCTION

            vm.toggleChosen = function (item) {
                if (utilityService.validateParmsValue(item.item_id) !== true) return;
                
                if (item.item_is_selected === '0') {
                    item.item_is_selected = '1';
                } else if (item.item_is_selected === '1') {
                    item.item_is_selected = '0';
                }
            };

            // #endregion TOGGLE CHOSEN FUNCTION

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                let selectedItems = [];

                vm.model.itemsListCalculationAndValidations.forEach((item) => {
                    if (item.item_filtervalue === undefined) return;
                    if (item.item_filtervalue.toLowerCase().indexOf(vm.model.setting.searchtext.toLowerCase()) === '-1') return;
                    if (item.item_id === '0' || item.item_id === '-1') return;
                    if (item.item_is_selected === '0') return;

                    selectedItems.push({
                        item_id: item.item_id,
                        item_is_selected: item.item_is_selected
                    });
                });

                checkListItemCvsService.saveObj({
                    checklistitem_keyno: vm.model.setting.checklistitem_keyno,
                    records: selectedItems
                }).then(function (response) {
                    if (response[0].errorcode !== '0') {
                    	modalService.show({
                    		type: 'warning',
                    		title: translations.error,
                    		message: response[0].errormessage,
                    		buttons: [{
                    			label: translations.ok,
                    			cssClass: 'btn-warning',
                    			action: function (dialogItself) {
                    				dialogItself.close();
                    				vm.model.lockedSave = false;
                    			}
                    		}]
                    	});
                    } else {
                    	vm.model.lockedSave = false;
                    	stateService.back();
                    }
                });
            }

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                translate();
                await loadSetting();
                loadCalculationAndValidations();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
